import { useEffect, useState } from 'react';
import noAvailableImg from '@/assets/img/noTreeImg.png';
import calendarSvg from '@/assets/svg/calendar.svg';
import locationSvg from '@/assets/svg/location.svg';
import { treeHasPhoto } from '@/components/Project/treeOrder';
import {
  Box,
  Container,
  Dots,
  FarmerDetails,
  FarmerImage,
  FarmerInfo,
  FarmerName,
  FID,
  Wrapper,
} from '@/components/TreeCard/TreeCard.styles';
import { formatDate } from '@/constants/formatDate';

interface TreeCardProps {
  photo: string;
  location: string;
  fid: string;
  planting_date?: string;
}

// TODO: Planting_date - convert to camelCase after types refactor
export const TreeCard = ({ photo, location, fid, planting_date }: TreeCardProps) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  // Founder 2026-09-21 (trees-2, item 3): show the "Coming soon" placeholder
  // when the photo field is NULL/empty AND when the image fails to load (many
  // upstream URLs 404 - see item 1). A bare `photo ?? placeholder` missed the
  // empty-string case ('' is not nullish), so an empty field rendered a broken
  // <img> instead of the placeholder.
  const [imageSrc, setImageSrc] = useState(treeHasPhoto(photo) ? photo : noAvailableImg);

  useEffect(() => {
    setImageSrc(treeHasPhoto(photo) ? photo : noAvailableImg);
    setIsImageLoading(true);
  }, [photo]);

  return (
    <Container>
      {isImageLoading && (
        <Wrapper>
          <Dots />
        </Wrapper>
      )}
      <FarmerImage
        src={imageSrc}
        onLoad={() => setIsImageLoading(false)}
        onError={() => {
          // Swap to the placeholder once; never re-loop if the placeholder
          // itself somehow errors.
          setIsImageLoading(false);
          if (imageSrc !== noAvailableImg) setImageSrc(noAvailableImg);
        }}
      />
      <FarmerInfo>
        <FarmerName>
          TREE NR: <FID>#{fid}</FID>
        </FarmerName>
        <Box>
          <FarmerDetails>
            <img src={locationSvg} />
            <p>{location || 'Missing data'}</p>
          </FarmerDetails>
          <FarmerDetails>
            <img src={calendarSvg} />
            <p>{formatDate(planting_date)}</p>
          </FarmerDetails>
        </Box>
      </FarmerInfo>
    </Container>
  );
};
